<template>
  <div class="judgment_detail_box border_box" @click="hideCopyContentfun">
    <div class="tab_bar_box border_box flex_v_center">
      <div class="left_box">
        <i class="back_icon" @click="goback"></i>
      </div>
      <div class="right_box">
        <i class="copy_icon" @click.stop="showCopyContentfun"></i>复制
        <div class="copy_content" :class="showCopyContent?'active':''">
          <p ref="copyAlls" @click="copyInfo(1)">复制全部</p>
          <p @click="copyInfo(1,k)" v-for="(item,k) of userCopyTemplate" :key="item.id">{{ item.templateName }}</p>
          <p @click="copyInfo(2)">复制标题和链接</p>
          <p @click="copyInfo(3)">复制标题和正文</p>
        </div>
      </div>
    </div>
    <div class="detail_content_box" :class="isIOS ? 'marginbotm2' : 'marginbotm'">
      <div class="info_box border_box">
        <h1 class="info_title">
          <!-- 预警级别 -->
          <warningLevel
            v-if="CONSTANT.WARNING_LEVEL.includes(detailInfo.warningClass)"
            :warning-level="detailInfo.warningClass"
            :warning-time-array="detailInfo.warningTimeArray"
            class-name="level-push-warning-list"
          ></warningLevel>
          <span class="info_title" v-html="detailInfo.title" style="margin-right:10px"></span>
          <div class="copy_box" @click="copyInfo(4)">
            <div class="copy_blue_icon"></div>
          </div>
        </h1>
        <div class="info_source_time_box border_box flex_v_center">
          <p>
            <span class="info_tendency zheng" v-if="detailInfo.orientation == 1">正</span>
            <span class="info_tendency fu" v-else-if="detailInfo.orientation == 2">负</span>
            <span class="info_tendency zhong" v-else-if="detailInfo.orientation == 3">中</span>
            <span ref="source" :style="'width:'+ leftWidth / 75 + 'rem'"  class="info_source ellipsis" @click.stop="showFullSourceinfo(detailInfo.webname,leftWidth)">{{detailInfo.webname}}</span>
            <span ref="author" :style="'width:'+ centerWidth / 75 + 'rem'"  class="info_author ellipsis" @click.stop="showFullAuthorinfo(detailInfo.author,centerWidth)">{{detailInfo.author}}</span>
          </p>
          <p>
            <span class="info_time">{{detailInfo.publishTime}}</span>
          </p>
        </div>
        <p v-show="isShow" class="show_fullinfo">{{ fullinfo }}</p>
        <span  class="info_link">原文链接：</span>
        <a :href="detailInfo.url1" class="view_original" @click="detailInfoUrls()" style="margin-right:10px">{{detailInfo.url1}}</a>
        <div class="copy_box" @click="copyInfo(5)">
          <div class="copy_blue_icon"></div>
        </div>
      </div>
      <DetailAi v-if="detailInfo.title" :detailInfo="detailInfo"></DetailAi>
      <!-- 内容 -->
      <div class="detail-video-box" v-if="detailInfo.videoUrls">
        <video
          id="detailVideo"
          :src="detailInfo.videoUrls"
          controls="controls"
          objectfit="contain"
          style="height: 100%;width: 100%;outline: none;background-color: #000;"
        ></video>
      </div>
      <div class="detail-video-box" v-else-if="detailInfo.imgUrls && detailInfo.imgUrls.length">
        <img :src="detailInfo.imgUrls[0]" />
      </div>
      <div class="judgment_txt_box border_box" v-if="detailInfo.content">
        <div v-if="detailInfo.mediaSourceType === 11" class="title_box"><i></i><span>简介</span></div>
        <span v-html="detailInfo.content"></span>
        <div class="copy_box" @click="copyInfo(6)">
          <div class="copy_blue_icon"></div>
        </div>
      </div>
      <div class="detail-ai-bottom">
        <div class="bottom-box">本页面生成的内容为Al智能生成，均不代表本平台/系统的观点和立场</div>
        <div class="bottom-box">系统对其生成内容不承担任何责任，请谨慎甄别。</div>
      </div>
      <!-- 抽帧OCR -->
      <div v-if="detailInfo.ocrContentList && detailInfo.ocrContentList.length"  class="judgment_txt_box border_box">
        <div class="title_box"><i></i><span>抽帧OCR</span></div>
        <div v-for="(item, i) of detailInfo.ocrContentList" :key="i">
          <span v-html="item.ocrtext"></span>
          <div v-if="i === detailInfo.ocrContentList.length - 1" class="copy_box" @click="copyInfo(7)">
            <div class="copy_blue_icon"></div>
          </div>
        </div>
      </div>
      <!-- 语音识别 -->
      <div v-if="detailInfo.istarAsr" class="judgment_txt_box border_box">
        <div class="title_box"><i></i><span>语音识别</span></div>
        <span v-html="detailInfo.istarAsr"></span>
        <div class="copy_box" @click="copyInfo(8)">
          <div class="copy_blue_icon"></div>
        </div>
      </div>
      <div class="ocr_img_box">
        <div v-for="(item, i) of detailInfo.ocrContentList" :key="'img' + i">
          <img :src="item.imgurl" alt="">
        </div>
      </div>
      <!-- 仅转发、转发评论、评论内容 -->
      <div
        v-if="detailInfo.originInfo && detailInfo.originInfo.originContent"
        class="detail-origin-box border-box"
        :class="detailInfo.originInfo.originAttitude === CONSTANT.TENDENCYLIST[0].INDEX ? 'positive-bg' : (detailInfo.originInfo.originAttitude === CONSTANT.TENDENCYLIST[2].INDEX ? 'negative-bg' : 'neutral-bg')"
      >
        <div class="detail-origin-top border-box item-vertical">
          <div class="origin-top-left border-box flex-verticle">
            <div class="origin-user-icon border-box">
              <img
                v-if="!!detailInfo.originInfo.originAuthorAvatarUrl"
                :src="detailInfo.originInfo.originAuthorAvatarUrl"
                alt=""
              >
              <i v-else class="iconfont icon-portrait user-icon"></i>
            </div>
            <span class="info-nakename">{{ detailInfo.originInfo.originAuthor }}</span>
            <span class="line">/</span>
            <span class="info-time">{{ detailInfo.originInfo.originPublishTime }}</span>
          </div>
        </div>
        <div class="detail-origin-txt border-box" v-html="detailInfo.originInfo.originContent"></div>
        <!-- 译文 -->
        <div v-if="detailInfo.translateContent" id="translate">
          <div class="flex item-vertical">
            <span class="translate-line flex-1"></span>
            <span class="translat-txt">译文</span>
            <span class="translate-line flex-1"></span>
          </div>
          <div class="detail-origin-txt border-box selection-tag" v-html="detailInfo.translateContent"></div>
        </div>
      </div>
      <!-- 仅转发、转发评论、评论内容end -->
      <div class="judgment_video_box" v-if="detailInfo.smallVideo">
        <img v-if="!detailInfo.smallVideoCover" class="default_img" :src="defaultImageList[detailInfo.smallVideoType]"/>
        <img v-if="detailInfo.smallVideoCover" class="link_img" :src="detailInfo.smallVideoCover"/>
        <a :href="detailInfo.url">观看<span> 原视频 </span>请点击前往</a>
      </div>
    </div>
    <!-- 下载 -->
    <!-- <div class="download_box border_box flex_between" v-if='yqmsorigin'>
      <div class="yqms_logo_box border_box">
        <img src="../../../assets/images/judgment/yqms_logo.svg" class="yqms_logo" />
        <span class="logo_txt">舆情秘书</span>
      </div>
      <a href="https://dl.istarshine.com/yqms/FBaddress/yqmsfb.html" class="download_btn border_box">下载</a>
    </div> -->
    <!-- 授权 -->
    <div class="van-overlay" v-show="showOverlay">
      <div class="wrapper">
        <div class="block">
          <div class="head">安全校验</div>
          <div class="info">为保证信息安全性，请<span>授权</span>后再查看信息详情或访问原链查看信息详情</div>
          <div class="button-w">
            <div class="div1" @click="jzUrl()">访问原链接</div>
            <div @click="showYzmpage()">去授权</div>
          </div>
        </div>
      </div>
    </div>
    <div class="van-overlay van-overlay1" v-show="showOverlayyz">
      <div class="tab_bar_box border_box flex_v_center flex_v_1">
        <div class="left_box">
          <i class="back_icon" @click="showOverlayyz = false;showOverlay=true"></i>
        </div>
        <div class="flex-1">手机号授权</div>
      </div>
      <div class="van-overlay-warys">
        <div class="item">
          <input type="tel" class="van-field__control"  v-model="phones" placeholder="请输入手机号"  >
        </div>
        <p class="error-info showError" ></p>
        <div class="item item-verification">
          <input type="" class="van-field__control"  v-model="verification" placeholder="请输入验证码"  />
          <p v-if="codeLoginIng.isCountdown" @click="getYzm">获取验证码</p>
          <p v-else>重新发送({{ codeLoginIng.countdown }})</p>
        </div>
        <p class="error-info top10" :class="phones_error ? 'showError': ''">{{phones_error}}</p>
        <div class="item-button" @click="setSubmit">
          完成
        </div>
      </div>
    </div>

    <div class="van-overlay" v-show="notWeixin">
      <div class="wrapper">
        <div class="block">
          <div class="head">提示</div>
          <div class="info">为保证信息安全性，请您在微信环境中打开此页面。</div>
          <div class="button-w"></div>
        </div>
      </div>
    </div>

    <!-- 授权结束 -->
  </div>
</template>
<script>
import {handleClipboard} from '../../../assets/js/clipboard';
import { fetch } from "@/helpers/fetch"
import { Notify,Toast } from 'vant';
import { getDetailsInfo } from '@/api/judgment'
import { wxShare } from '@/helpers/wxconfig'
import { getSimpleText } from '@/helpers/util.js'
import warningLevel from '@/components/warningLevel/warningLevel'
import DetailAi from '@/pages/pushwarning/detail/components/detailAi/index.vue'
import { getUserCopy } from '@/api/wechat'
import CONSTANTS from '@/helpers/constant'
import VueCookies from 'vue-cookies'
import store from '@/store'
let moment = require("moment");
export default {
  name: 'pushwarningdetail',
  components: {
    "warningLevel":warningLevel,
    DetailAi
  },
  data(){
    return {
      codeLoginIng: {
        isCountdown: true,
        countTimer: '',
        countdown: 60
      },
      phones:'',
      verification:'',
      phones_error:'',
      yzm_error:'',
      showOverlay:false,
      showOverlayyz:false,
      notWeixin: false,
      detailInfo: {
        title:'',                   //标题
        content:'',                 //内容
        url:'',                     //原文连接
        Base64url:'',               //base64 url
        author:'',                  //作者
        publishTime:'',             //发布时间
        orientation:'',             //倾向性  1 正 2负  3中
        isRead:'',                  //是否已读
        proposal:'',                //处置建议
        webname:'',                 //来源
        abstracts:'',               //摘要
        keyword:'',                 //关键词
        overseas:'',                //是否境外
        simhash:'',                 //信息simhash
        isReport:'',                //加入简报
        infoid:'',                  //infoid
        tags:[],                    //事件分类
        isMyAttention:'0',          //是否加入过关注    0 否 1是
        warningLevel:'',            //0：一般，1：中等，2：严重，3：高危
        originInfo: {},           //仅转发、转发评论、评论内容
        mediaSourceType: '', // 媒体类型
        ocrContentList: [],
        istarAsr: '',
      },
      defaultImageList: {
        '1':require('../../../assets/images/smallvideo/volcano_list.png'),//火山
        '2':require('../../../assets/images/smallvideo/watermelon_list.png'),//西瓜
        '3':require('../../../assets/images/smallvideo/sp_list.png'),//秒拍
        '4':require('../../../assets/images/smallvideo/quickhand_list.png'),//快手
        '5':require('../../../assets/images/smallvideo/shakes_list.png'),//抖音
        '6':'',                                                   //微视
        '7':require('../../../assets/images/smallvideo/mp_list.png'),//美拍
        '8':require('../../../assets/images/smallvideo/bili_list.png'),//哔哩哔哩
        '10':require('../../../assets/images/smallvideo/qm_list.png'),//全民
      },
      uuid:'',                      //信息uuid
      simhash:'',                   //信息simhash
      infoid:'',                    //信息infoid
      isIOS: false,
      yqmsorigin: false,
      showCopyContent:false,
      isShow: false,
      fullinfo: '',
      windowBodyWidth: document.body.clientWidth,
      count1: 0,
      count2: 0,
      CONSTANT:{
        ...CONSTANTS
      },
      copyArr: [],
      copyInfoTemplate: [],
      userCopyTemplate: []
    }
  },
  computed: {
    leftWidth() {
      let len = this.getKeywordWidth(this.detailInfo.webname,24)
      if(len < 180) {
        return len
      } else {
        return 180
      }
    },
    centerWidth() {
      return  (this.windowBodyWidth * 2) - this.leftWidth - 450
    }
  },
  methods: {
    showFullSourceinfo(info,width) {
      this.$refs.author.style.color = '#999'
      this.count1++
      this.count2 = 0
      let len = this.getKeywordWidth(info,24)
      if( len <= width) {
        this.isShow = false
        this.$refs.source.style.color = '#999'
      } else {
        if(this.count1 % 2) {
          this.isShow = true
          this.$refs.source.style.color = '#5090f1'
        } else {
          this.isShow = false
          this.$refs.source.style.color = '#999'
        }

        this.fullinfo = info
      }
    },
    showFullAuthorinfo(info,width) {
      this.$refs.source.style.color = '#999'
      this.count1 = 0
      this.count2++
      let len = this.getKeywordWidth(info,24)
      if( len <= width) {
        this.isShow = false
        this.$refs.author.style.color = '#999'
      } else {
        if(this.count2 % 2) {
          this.isShow = true
          this.$refs.author.style.color = '#5090f1'
        } else {
          this.isShow = false
          this.$refs.author.style.color = '#999'
        }
        this.fullinfo = info
      }
    },
    getKeywordWidth(words,fontSize) {
      const len = this.checksum(words) // 字符个数
      const keyLen = !!words && words.split(',').length
      const allLen = (len + keyLen - 1) * fontSize / 2
      return allLen
    },
    checksum(chars) {
      let sum = 0
      for (let i = 0; i < chars.length; i++) {
        const c = chars.charCodeAt(i)
        if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
          sum++
        } else {
          sum += 2
        }
      }
      return sum
    },
    queryData(){
      Toast.loading({
        duration: 0,       // 持续展示 toast
        mask: true,
        message: '加载中...'
      })
      let params = {
        id: this.uuid
      }
      getDetailsInfo(params).then(res => {
        Toast.clear();
        if(res.data.status == '0'){
          let result = res.data.result.data;
          if(result != ''){
            this.detailInfo.title = result.title;
            // document.title = result.copyTitle;
            this.detailInfo.copyTitle = result.copyTitle;
            this.detailInfo.content = result.content;
            this.detailInfo.copyContent = result.copyContent;
            this.detailInfo.url = result.url;
            if(result.webname == '抖音') {
              const url = this.detailInfo.url
              this.detailInfo.url1 = url.split('####')[0].replace(/#orc/g, '').replace(/#att/g, '').replace(/#asr/g, '').replace(/iesdouyin/g, 'douyin')
            }else if(result.webname == '微信视频号') {
              this.detailInfo.url1 = result.appUrl?result.appUrl:result.url;
            }else {
              this.detailInfo.url1 = result.url;
            }
            // this.detailInfo.Base64url = Base64.encode(info.url);
            this.detailInfo.author = result.author;
            this.detailInfo._publishTime = result.publishTime;
            this.detailInfo.webUrl = result.webUrl;
            this.detailInfo.publishTime = moment(result.publishTime, "YYYYMMDDHHmmss").format('YYYY-MM-DD HH:mm:ss');
            this.detailInfo.copyPublishTime2 = moment(result.publishTime, "YYYYMMDDHHmmss").format('M月D日');
            this.detailInfo.orientation = result.orientation;
            this.detailInfo.isRead = result.isRead;
            this.detailInfo.authorInfo = result.authorInfo;
            this.detailInfo.webname = result.webname;
            this.detailInfo.industryTags = result.industryTags;
            this.detailInfo.proposal = result.proposal;
            this.detailInfo.warningLevel = result.warningLevel;
            this.detailInfo.abstracts = result.abstracts;
            this.detailInfo.copyAbstracts = result.copyAbstracts;
            this.detailInfo.simhash = result.simhash;
            this.detailInfo.infoid = result.infoId;
            this.detailInfo.keyword = result.keyword;
            this.detailInfo.postPlace = result.postPlace || '';
            this.detailInfo.visitCount = result.visitCount || '';
            this.detailInfo.praiseCount = result.praiseCount || '';
            this.detailInfo.ipRegion = result.ipRegion || '';
            this.detailInfo.authorCptLocation = result.authorCptLocation || '';
            this.detailInfo.className = result.className || '';
            this.detailInfo.subjectName = result.subjectName || '';
            this.detailInfo.overseas = result.overseas;
            this.detailInfo.isReport = result.isReport;
            this.detailInfo.isMyAttention = result.isMyAttention;
            this.detailInfo.replyNum = result.replyNum;
            this.detailInfo.forwardNum = result.forwardNum;
            this.detailInfo.smallVideo = result.smallVideo;
            this.detailInfo.smallVideoCover = result.smallVideoCover;
            this.detailInfo.smallVideoType = result.smallVideoType;
            this.detailInfo.mediaType = result.sourceType;
            this.detailInfo.authType = result.authType;
            this.detailInfo.aiSummaryState = result.aiSummaryState;
            this.detailInfo.fansCount = result.authorFansCount;
            this.detailInfo.indexSuffix = result.indexSuffix;
            this.detailInfo.dataType = result.dataType;
            this.detailInfo.warningClass = result.warningClass;
            this.detailInfo.tags = JSON.parse(result.tags);
            this.detailInfo.originInfo = result.originInfo
            this.detailInfo.mediaSourceType = result.mediaSourceType
            this.detailInfo.ocrContentList = result.ocrContentList || ''
            this.detailInfo.istarAsr = result.istarAsr || ''
            this.detailInfo.copyIstarAsr = result.copyIstarAsr
            this.detailInfo.videoUrls = result.videoUrls || ''
            this.detailInfo.authorSourceId = result.authorSourceId || ''
            this.detailInfo.contentMentionRegionList = result.contentMentionRegionList
            this.detailInfo.area = (result.contentMentionRegionList && result.contentMentionRegionList.length) ?  result.contentMentionRegionList[0].split('-')[0] : ''
            this.detailInfo.firstIndustryTag = result.firstIndustryTag || ''
            this.detailInfo.secondIndustryTag = result.secondIndustryTag || ''
            this.detailInfo.subjectName = result.subjectName || ''
            this.detailInfo.catelogName = result.catelogName || ''
            this.detailInfo.className = result.catelogName || ''
            // 预警级别
            if (result.warningTimeArray && result.warningTimeArray.length) {
              this.detailInfo.warningTimeArray = this.handleWarningTimeArray(result.warningTimeArray)
            }
            // 发布时间
            if(result.originInfo && result.originInfo.originPublishTime) {
              this.detailInfo.originInfo.originPublishTime = moment(result.originInfo.originPublishTime).format('YYYY-MM-DD HH:mm')
            }
            wxShare(result.copyTitle,result.copyAbstracts,this);
            this.setNewLog({
              module:'9',
              mediaType:this.detailInfo.mediaType || '',
              operation:'38'
            })
            setTimeout(()=>{
              this.setVideoEev()
            },0)
          }
        }
      }).catch(err=>{
        console.log(err);
      });
    },
    setVideoEev(){
      if(this.detailInfo.videoUrls){
        const elevideo = document.getElementById('detailVideo')
        elevideo && elevideo.addEventListener('playing', this.addMaiDian)
      }
    },
    addMaiDian(){
      this.setNewLog({
        module:'9',
        mediaType:this.detailInfo.mediaType || '',
        operation:'41'
      })
    },
    // 处理时间记录
    handleWarningTimeArray(arr) {
      const strtime = 'YYYY-MM-DD HH:mm'
      arr.forEach(item => {
        item.warningTimes = moment(item.time).format(strtime)
        item.text = (item.level) ? this.CONSTANT.WARNING_LEVEL_INFO[item.level].TEXT : '—'
        item.desc = item.desc ? item.desc : '—'
      })
      return arr
    },
    getUserCopy() {
      let params = {
        openid: store.state.userInfo.openid
      }
      const _this = this
      getUserCopy(params).then(function(res) {
        const {code,data} = res.data
        if (code === 200) {
          const {copyInfoTemplate,oldCopyInfoTemplate,userCopyTemplate} = data
          _this.copyArr = oldCopyInfoTemplate // 之前的
          _this.copyInfoTemplate = copyInfoTemplate  //新的
          _this.userCopyTemplate = userCopyTemplate  //新的
        }
      }).catch(err => {
        console.log(err, '请求失败！');
      });
    },
    async newCopyInfo(copyInfoTemplate){
      const mediaSourceType = this.detailInfo.mediaSourceType || ''
      const webName = this.detailInfo.webname || ''
      const copyitemInfo = [...this.CONSTANT.COPYITEM] 
      var aiSummary = this.detailInfo.aiSummaryState === 1 ? this.detailInfo.copyAbstracts : (this.detailInfo.aiSummary || '')
      if (copyInfoTemplate.indexOf('${aiAbstract}') > -1) {
        if (!aiSummary) {
          aiSummary = await this.getAiSummary()  
        }
      } 
      this.detailInfo.aiSummary = aiSummary || '-1' 
      copyitemInfo.forEach(item=>{
        if (item.id === '20' && copyInfoTemplate.indexOf(item.replace) > -1){
          // 视频文件地址 并且包含
          if (mediaSourceType+'' === '11') {
            const s = this.getKeyValue(item.id, '', true)
            const rexp = new RegExp('\\' + item.replace, 'g')
            copyInfoTemplate = copyInfoTemplate.replace(rexp, s)
          }else{
            const str1 = `${item.name}:${item.replace}\n`
            const str2 = `${item.name}:${item.replace}`
            const str3 = `${item.replace}\n`
            const str4 = `${item.replace}`
            let regExpString = item.name + ':' + '\\' + item.replace
            // const regExpString = (copyInfoTemplate.indexOf(str) > -1) ? item.name + ':' + '\\' + item.replace + '\n' : item.name + ':' + '\\' + item.replace
            if (copyInfoTemplate.indexOf(str1) > -1) {
              regExpString = item.name + ':' + '\\' + item.replace + '\n'
            } else if (copyInfoTemplate.indexOf(str2) > -1) {
              regExpString = item.name + ':' + '\\' + item.replace
            } else if (copyInfoTemplate.indexOf(str3) > -1) {
              regExpString = `\\${item.replace}\n`
            } else if (copyInfoTemplate.indexOf(str4) > -1) {
              regExpString = `\\${item.replace}`
            }
            const rexp = new RegExp(regExpString, 'g')
            copyInfoTemplate = copyInfoTemplate.replace(rexp, '')
          }
        }else if (item.id === '18' || item.id === '19' || item.id === '28') {
          // 抖音
          if ((item.id === '18' && webName === '抖音') || (item.id === '19' && webName === '快手') || (item.id === '28' && webName === '小红书')) {
            const s = this.getKeyValue(item.id, '', true)
            const rexp = new RegExp('\\' + item.replace, 'g')
            copyInfoTemplate = copyInfoTemplate.replace(rexp, s)
          } else {
            // 不是抖音
            const str1 = `${item.name}:${item.replace}\n`
            const str2 = `${item.name}:${item.replace}`
            const str3 = `${item.replace}\n`
            const str4 = `${item.replace}`
            let regExpString = item.name + ':' + '\\' + item.replace
            // const regExpString = (copyInfoTemplate.indexOf(str) > -1) ? item.name + ':' + '\\' + item.replace + '\n' : item.name + ':' + '\\' + item.replace
            if (copyInfoTemplate.indexOf(str1) > -1) {
              regExpString = item.name + ':' + '\\' + item.replace + '\n'
            } else if (copyInfoTemplate.indexOf(str2) > -1) {
              regExpString = item.name + ':' + '\\' + item.replace
            } else if (copyInfoTemplate.indexOf(str3) > -1) {
              regExpString = `\\${item.replace}\n`
            } else if (copyInfoTemplate.indexOf(str4) > -1) {
              regExpString = `\\${item.replace}`
            }
            const rexp = new RegExp(regExpString, 'g')
            copyInfoTemplate = copyInfoTemplate.replace(rexp, '')
          }
        } else if (item.id === '31' && aiSummary) {
          const rexp = new RegExp('\\' + item.replace, 'g')
          const aiSummaryData = aiSummary === '-1' ? this.detailInfo.content.replace(/<[^>]*>/g, '') : aiSummary
          copyInfoTemplate = copyInfoTemplate.replace(rexp, aiSummaryData)
        } else {
          const s = this.getKeyValue(item.id, '', true)
          const rexp = new RegExp('\\' + item.replace, 'g')
          copyInfoTemplate = copyInfoTemplate.replace(rexp, s)
        }

      })
      return copyInfoTemplate
    },
  async copyInfo(type,index){
      let _this = this;
      let content = '';
      if(type == 1){//复制全部
        if(this.copyInfoTemplate && this.copyInfoTemplate.length){
          //新复制模版
          let template = this.copyInfoTemplate
          if(index+'' === '0'|| index){
            template = this.userCopyTemplate[index] ? this.userCopyTemplate[index].template : template
          }
          content = await this.newCopyInfo(template) 
        }else{
          this.copyArr.map(item=>{
            const name = store.state.userInfo.isShowFieldName ? `${item.name}：` : ''
            content += '\n' + this.getKeyValue(item.id,name)
          })
        }
      }
      if(type == 2){//复制标题和链接
        content = content + '标题：' + getSimpleText(this.detailInfo.copyTitle) + '\n';
        content = content + '链接：' + this.detailInfo.url1 + '\n';
      }
      if(type == 3){//复制标题和正文
        content = content + '标题：' + getSimpleText(this.detailInfo.copyTitle) + '\n';
        content = content + '正文：' + getSimpleText(this.detailInfo.copyContent);
      }
      if(type == 4){//复制标题
        content = content + '标题：' + getSimpleText(this.detailInfo.copyTitle);
      }
      if(type == 5){//复制链接
        content = content + this.detailInfo.url1;
      }
      if(type == 6){//复制正文
        content = content + '正文：' + getSimpleText(this.detailInfo.copyContent);
      }
      if(type == 7){//抽帧OCR
        let tempStr = ''
        this.detailInfo.ocrContentList.forEach(item=>{
          tempStr += getSimpleText(item.copyOcrtext)
        })
        content = content + '抽帧OCR：' + tempStr;
      }
      if(type == 8){//语音识别
        content = content + '语音识别：' + getSimpleText(this.detailInfo.copyIstarAsr);
      } 
     handleClipboard(content, event, () => {
        Notify({
          message: '复制成功',
          duration: 1000,
          color: "",
          className: "notifyNew",
          background: ''
        });
        let params = {
          uuid: _this.uuid,
          infoType: '4' //1 专题 、2预警、3舆情研判微信端 、4推送预警微信端
        }
        _this.$store.commit('saveCopyInfo',params);
      }, () => {
        Notify({
          message: '复制失败！',
          duration: 1000,
          color: "",
          className: "notifyErr",
          background: ''
        });
      });
      this.setNewLog({
        module:'9',
        mediaType:this.detailInfo.mediaType || '',
        operation: (type == 5) ? '40' : '39'
      })
    },
    handleClipboardData(content){ 
      // const clipboard = document.createElement('textarea')
      // clipboard.value = content
      // document.body.appendChild(clipboard)
      // clipboard.select() // 选择对象
      // document.execCommand('Copy', false, true) // 执行浏览器复制命令
      // clipboard.remove()
      // 创建临时textarea元素
      const textarea = document.createElement('textarea');
      textarea.value = content;
      
      // 防止屏幕闪烁
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      textarea.style.left = '-9999px';
      textarea.style.top = '10px';
      textarea.setAttribute('readonly', 'readonly');
      
      document.body.appendChild(textarea);
      
      // 兼容iOS设备
      if (navigator.userAgent.match(/iphone|ipad|ipod/i)) {
        textarea.contentEditable = true;
        textarea.readOnly = true;
        const range = document.createRange();
        range.selectNodeContents(textarea);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        textarea.setSelectionRange(0, 999999);
      } else {
        textarea.select();
      }
      
      // 执行复制 
      document.execCommand('copy'); 
      // 清理DOM
      document.body.removeChild(textarea); 
      Notify({
        message: '复制成功',
        duration: 1000,
        color: "",
        className: "notifyNew",
        background: ''
      });
      this.setNewLog({
        module:'9',
        mediaType:this.detailInfo.mediaType || '',
        operation: '39'
      })
    },
    detailInfoUrls(){
      this.setNewLog({
        module:'9',
        mediaType:this.detailInfo.mediaType || '',
        operation:'40'
      })
    },
    hideCopyContentfun(){
      this.showCopyContent = false;
      this.isShow = false
      this.count1 = 0
      this.count2 = 0
      this.$refs.author.style.color = '#999'
      this.$refs.source.style.color = '#999'
    },
    showCopyContentfun(){
      this.showCopyContent = true;
    },
    goback(){
      window.history.go(-1);
    },
    isValidPhoneNumber(phoneNumber){
      const phoneRegex = /^1[0-9]{10}$/;
      return phoneRegex.test(phoneNumber);
    },
    getYzm(){
      this.phones_error = ''
      if(!this.phones){
        this.phones_error = '请输入手机号！'
        return false
      }
      if(!this.isValidPhoneNumber(this.phones)){
        this.phones_error = '请输入正确的手机号！'
        return false
      }
      this.getSendCode()
    },
    async getSendCode(){
      let url = '/api/usercenter/AuthorizationController/sendCode'
      let p ={
        url: url,
        method: 'get',
        params: {
          telphone:this.phones
        }
      }
      let res = await fetch(p)
      let { data } = res
      if(data.status == 1){
        this.phones_error = '验证码已发送手机，请注意查收！'
        this.setTime(this.codeLoginIng)
      }else{
        this.phones_error = data.msg
      }
    },
    async setSubmit(){
      this.phones_error = ''
      if(!this.phones){
        this.phones_error = '请输入手机号！'
        return false
      }
      if(!this.isValidPhoneNumber(this.phones)){
        this.phones_error = '请输入正确的手机号！'
        return false
      }
      if(!this.verification){
        this.phones_error = '请输入验证码！'
        return false
      }
      let url ='api/usercenter/AuthorizationController/checkCode'
      let p = {
        url: url,
        method: 'get',
        params:{
          telphone:this.phones,
          code:this.verification,
        }
      }
      let res = await fetch(p)
      let { data } = res
      if(data.status == 1){
        document.body.style.overflowY = 'auto'
        this.phones_error = '验证通过'
        this.showOverlayyz = false
        const date = new Date()
        const minutes = 1440 * 7
        date.setTime(date.getTime() + (minutes * 60 * 1000))
        VueCookies.set('AUTHORISE', 1, { expires: date, path: '/' })
        VueCookies.set('TELPHONES', this.phones, { expires: date, path: '/' })
      }else{
        this.phones_error = data.msg
      }
      this.setLog()
    },
    setLog(){
      let data = {
        token:"bG9ncHJvY2Vzcw==",
        telphone:this.phones, //手机号
        url:window.location.href,// url
        userId:'',
        accountId:'',
        shareChannel:3, //分享渠道
        shareType:2, //分享类型 1 事件分析  2微信
        openId: this.$route.query.openid || ''
      }
      let url = '/v4/api/user/auth/log'
      let p = {
        url: url,
        method: 'post',
        istoken:true,
        data: data
      }
      fetch(p)
    },
    setNewLog(data){
      // data.token = "bG9ncHJvY2Vzcw=="
      // data.telphone = this.phones
      data.openid = this.$route.query.openid || ''
      let url = '/api/wechat/new/logs'
      let p = {
        url: url,
        method: 'post',
        data: data
      }
      fetch(p)
    },
    setTime(obj) {
      if (!obj.countdown) {
        obj.isCountdown = true
        obj.countTimer = null
        obj.countdown = 60
        return false
      } else {
        obj.isCountdown = false
        obj.countdown--
      }
      obj.countTimer = setTimeout(() => {
        this.setTime(obj)
      }, 1000)
    },
    showYzmpage(){
      this.showOverlay = false
      this.showOverlayyz = true
    },
    jzUrl(){
      if(this.detailInfo && this.detailInfo.url){
        window.location.href =  this.detailInfo.url
      }
    },
    getKeyValue(id,name){
      let content = '';
      let tendency = '';
      let mediaTypeName = ''
      const authType = this.detailInfo.authType + '' || ''
      if(this.detailInfo.orientation == 1) {
        tendency = '正面';
      }else if(this.detailInfo.orientation == 2) {
        tendency = '负面';
      }else if(this.detailInfo.orientation == 3) {
        tendency = '中性';
      }
      var itemdata = this.detailInfo
      switch(id) {
        case "1":
          content =  name + getSimpleText(itemdata.copyTitle);
          break;
        case "2":
          content = name + this.detailInfo.url1;
          break;
        case "3":
          content = name + getSimpleText(this.detailInfo.copyAbstracts).getAbstract();
          break;
        case "4":
          var times = moment(itemdata._publishTime, "YYYYMMDDHHmmss").format('YYYY-MM-DD HH:mm');
          if (itemdata.copyPublishTime) {
            times = moment(itemdata.copyPublishTime, "YYYYMMDDHHmmss").format('YYYY-MM-DD HH:mm');
          }
          content = name + times;
          break;
        case "5":
          content = name + this.detailInfo.webname;
          break;
        case "6":
          content = name + this.detailInfo.author;
          break;
        case "7":
          content = name + tendency;
          break;
        case "8":
          // isComment: 是否评论，0：非评论 1：评论，评论时不显示评论数和转发数
          content = name + this.detailInfo.replyNum;
          break;
        case "9":
          content = name + this.detailInfo.forwardNum;
          break;
        case "10":
          content = name + this.detailInfo.keyword;
          break;
        case '11' :
          if (authType === '3') {
            mediaTypeName = '蓝V'
          } else if (authType === '2') {
            mediaTypeName = '橙V'
          } else if (authType === '4') {
            mediaTypeName = '金V'
          } else {
            mediaTypeName = '普通用户'
          }
          content = name + mediaTypeName;
          break;
        case '12' :
          content = name + (this.detailInfo && this.detailInfo.fansCount ? this.detailInfo.fansCount : 0);
          break;
        case '13' : // 单位
          content = name + store.state.userInfo.unitName;
          break;
        case '14' : // 作者ID
          content = name + (this.detailInfo && this.detailInfo.authorSourceId ? this.detailInfo.authorSourceId : '');
          break;
        case '15' : // 涉事省份
          content = name + (this.detailInfo && this.detailInfo.area ? this.detailInfo.area : '');
          break;
        case '16' : // 涉事地域
          var region = this.getRegionData(itemdata)
          content = name + region;
          break;
        case '17' : // 日期
          var copyPublishTimeStr = this.detailInfo.publishTime
          if(this.detailInfo.copyPublishTime2){
            copyPublishTimeStr = this.detailInfo.copyPublishTime2
          }
          content = name + copyPublishTimeStr;
          break;
        case '18' : // 抖音号
          var authorUserAccountNum = this.detailInfo.authorInfo.authorUserAccountNum || ''
          content = name + authorUserAccountNum;
          break;
        case '19' : // 抖音号
          var authorUserAccountNum2 = this.detailInfo.authorInfo.authorUserAccountNum || ''
          content = name + authorUserAccountNum2;
          break;
        case '20' : // 抖音号
          if (this.detailInfo.mediaSourceType + '' === '11') {
            var videoUrls = this.detailInfo.videoUrls || ''
            content = name + videoUrls;
          }
          break;
        case '21' : // 签到地
          var postPlace = this.detailInfo.postPlace || ''
          var newStr = postPlace.replace(/<[^>]*>/g, '')
          content = name + newStr;
          break;
        case '22' : // 阅读数
          var visitCount = this.detailInfo.visitCount || 0
          content = name + visitCount;
          break;
        case '23' : // 点赞数
          var praiseCount = this.detailInfo.praiseCount || 0
          content = name + praiseCount;
          break;
        case '24' : // 标签
          var Tag = ''
          if (this.detailInfo.industryTags) {
            Tag = this.detailInfo.industryTags.join('、')
          }
          content = name + Tag
          break;
        case '25' : // 专题名称
          var subjectName = this.detailInfo.subjectName || ''
          content = name + subjectName;
          break;
        case '26' : // 专题分类名称
          var className = this.detailInfo.className || ''
          content = name + className;
          break;
        case '27' : // 信息发布地域
          var ipRegion = this.detailInfo.ipRegion || ''
          content = name + ipRegion
          break;
        case '28' : // 小红书号
          var authorUserAccountNum1 = this.detailInfo.authorInfo.authorUserAccountNum || ''
          content = name + authorUserAccountNum1;
          break;
        case '29' : // 作者地域
          var authorCptLocation = (this.detailInfo.authorCptLocation && this.detailInfo.authorCptLocation.length) ? this.detailInfo.authorCptLocation[0] : ''
          content = name + authorCptLocation;
          break;
        case '30' : // 文章类型
        var articleType = '原发'
          if (this.detailInfo.microBlogType === 5) {
            // 弹幕
            articleType = '弹幕'
          }
          if ((this.detailInfo.isCommentData === 1 || this.detailInfo.microBlogType + '' === '4') && this.detailInfo.originInfo) {
            // 评论
            articleType = '评论'
          }
          if (this.detailInfo.microBlogType === 2  && this.detailInfo.originInfo) {
            // 转发
            articleType = '转发'
          }
          if (this.detailInfo.microBlogType === 3&& this.detailInfo.originInfo) {
            //  回复并转发
            articleType = '转评'
          }
          content = name + articleType;
          break;
        case '31' : // AI摘要
           content = name + '';
            break;
        default:
          if (store.state.userInfo.isShowFieldName) {
            content = name;
          }
          break;
      }
      return content
    },
    getRegionData(itemdata){
      const provinceName = store.state.userInfo.provinceName // 省name
      const cityName = store.state.userInfo.cityName // 市name
      const countryName = store.state.countryName // 县name 
      let strData = provinceName
      if (cityName) {
        strData = strData + '-' + cityName
      }
      if (countryName) {
        strData = strData + '-' + countryName
      }
      const cmr = itemdata.contentMentionRegionList || []
      if (cmr.includes(strData)) {
        return strData
      } else {
        return cmr.length ? cmr[0] : ''
      }
    },
    async getAiSummary() {
      const item = this.detailInfo
      const p = {
        'url': item.hasOwnProperty('infoUrl') && item.infoUrl ? item.infoUrl : item.url,
        'content': item.content ? item.content : item._summary ? item._summary : item._title,
        // 'publishTime': item._publishTime,
        'publishTime': Number(new Date(item.publishTime).getTime()),
        'indexSuffix': item.indexSuffix,
        'dataType': item.dataType+'',
        'id': this.uuid,
        'index': item.index || null,
        'origin': 2
      }
       p.content = p.content.replace(/<[^>]*>/g, '');
      let data = {
        url: '/api/wechat/summary/ai',
        method: 'post',
        data: p
      } 
      var res = await fetch(data)  
      let refData = res.data || ""
      if (refData && refData.code === 200) {
        item.summary = refData.data.aiSummary 
        return refData.data.aiSummary || '-1'
      } else {
        return '-1'
      }
    }
  },
  mounted() {
    let query = this.$route.query;
    let isAuthorised = query.isAuthorised || ''
    let authorizev = VueCookies.get('AUTHORISE') || ''
    if(!authorizev && isAuthorised){
      //显示
      this.showOverlay = true
      document.body.style.overflowY = 'hidden'
    }else{
      const isWeiXin = navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1;
      if (!isWeiXin) {
        this.notWeixin = true
        return
      }
    }
    this.uuid = query.uuid;
    this.simhash = query.simhash;
    this.infoid = query.infoid;
    this.queryData();
    this.getUserCopy();
    let userAgent = navigator.userAgent || '';
    // this.isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1;
    this.isIOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("../../judgment/detail/detail.css");
@import url("./detail.css");
</style>
